import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CustomCapabilityConfigurationForm } from '../../../../../core/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

export const LOG_CRM_ACTIVITY_GOAL_ID = 'logCRMActivity';

@Component({
  selector: 'ai-log-crm-activity-capability-form',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, GalaxyFormFieldModule, MatCheckboxModule],
  templateUrl: './log-crm-activity-capability-form.component.html',
})
export class LogCrmActivityCapabilityFormComponent extends CustomCapabilityConfigurationForm {}
